export default {
	INGREDIENT_CATEGORIES: 'Ingredients categories'
};